import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { KeycloakUser } from '../models/keycloak-user.model';

@Injectable({
  providedIn: 'root'
})
export class KeycloakUserService {
  private http = inject(HttpClient);
  private readonly usersApiUrl = `${environment.apiBaseUrl}/keycloak-users`;

  getAll(): Observable<KeycloakUser[]> {
    return this.http.get<KeycloakUser[]>(this.usersApiUrl);
  }
}
